export default __webpack_public_path__ + "static/assets/med_pill_square_out_L1_solid_x_01_f.e1513fa6.png";